import React from 'react';
import { MessageCircle, Sparkles } from 'lucide-react';

const ChatWithAIButton = ({ 
  onClick, 
  context = {}, 
  variant = 'primary', 
  size = 'medium',
  position = 'inline',
  className = ''
}) => {
  const getButtonClasses = () => {
    const baseClasses = 'flex items-center space-x-2 font-medium rounded-lg transition-all duration-200 hover:scale-105 shadow-lg';
    
    // Size variations
    const sizeClasses = {
      small: 'px-3 py-1 text-sm',
      medium: 'px-4 py-2 text-sm',
      large: 'px-6 py-3 text-base'
    };
    
    // Variant styles
    const variantClasses = {
      primary: 'bg-gradient-to-r from-blue-500 to-purple-500 text-white hover:from-blue-600 hover:to-purple-600',
      secondary: 'bg-white text-blue-600 border-2 border-blue-500 hover:bg-blue-50',
      accent: 'bg-gradient-to-r from-purple-500 to-pink-500 text-white hover:from-purple-600 hover:to-pink-600',
      minimal: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
      floating: 'bg-gradient-to-r from-blue-500 to-purple-500 text-white hover:from-blue-600 hover:to-purple-600 shadow-xl'
    };
    
    // Position-specific classes
    const positionClasses = {
      inline: '',
      floating: 'fixed bottom-6 right-6 z-40 rounded-full',
      sticky: 'sticky top-4 z-30'
    };
    
    return `${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${positionClasses[position]} ${className}`;
  };

  const getButtonText = () => {
    if (context.title) {
      return `Chat about ${context.title}`;
    }
    return 'Chat with AI';
  };

  const getIcon = () => {
    if (position === 'floating') {
      return <Sparkles className="w-5 h-5" />;
    }
    return <MessageCircle className="w-4 h-4" />;
  };

  return (
    <button
      onClick={() => onClick(context)}
      className={getButtonClasses()}
      title={`Get AI help with ${context.title || 'this topic'}`}
    >
      {getIcon()}
      {position !== 'floating' && (
        <span>{size === 'small' ? 'AI Help' : getButtonText()}</span>
      )}
      
      {/* Floating button tooltip */}
      {position === 'floating' && (
        <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-black text-white px-2 py-1 rounded text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
          Chat with AI Tutor
        </div>
      )}
    </button>
  );
};

export default ChatWithAIButton; 